var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeachingStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 24C6.5 24 4.875 24 4.875 22.4C4.875 20.8 6.5 16 13 16C19.5 16 21.125 20.8 21.125 22.4C21.125 24 19.5 24 19.5 24H6.5Z",
    fill: "#128B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.48C15.2437 14.48 17.0625 12.6892 17.0625 10.48C17.0625 8.27087 15.2437 6.48001 13 6.48001C10.7563 6.48001 8.9375 8.27087 8.9375 10.48C8.9375 12.6892 10.7563 14.48 13 14.48Z",
    fill: "#128B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 0C1.45507 0 0 1.43269 0 3.2V18.4C0 19.7255 1.09131 20.8 2.4375 20.8H3.49842C3.78327 19.7976 4.33076 18.647 5.23052 17.6H1.625V3.2C1.625 2.31634 2.35254 1.6 3.25 1.6H22.75C23.6475 1.6 24.375 2.31634 24.375 3.2V17.6H20.7695C21.6692 18.647 22.2167 19.7976 22.5016 20.8H23.5625C24.9087 20.8 26 19.7255 26 18.4V3.2C26 1.43269 24.5449 0 22.75 0H3.25Z",
    fill: "#128B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachingStaff);
export default __webpack_public_path__ + "static/media/teaching-staff.4f1d78ac3c7e9742efb73e43dd838efe.svg";
export { ForwardRef as ReactComponent };